import { defaultAuthValues } from '../../../../app/config';
import { rootApi } from '../../../../app/stores/baseQuery';
import { AuthDto, AuthResponse } from '../../types';

export const authApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    auth: builder.mutation<AuthDto, { login: string; password: string }>({
      query: (params) => ({
        url: 'auth',
        body: { data: { ...defaultAuthValues, ...params } },
        method: 'POST',
      }),
      transformResponse: (result: AuthResponse): AuthDto => result.LogonResult.data,
    }),
  }),
});

export const { useAuthMutation } = authApi;
